export interface GameStatus {
  game?: string;
  title: string;
  value: string | number;
  notCurrencyValue?: boolean;
}

export type GameStatusesFF = Record<string, { title: string; value: number }>;
